import Config from "../../../Config";
import Listing_screen from "../proposal_screen.js/listing_screen";
import React from "react";
import { withRouter } from "react-router-dom";

class BusinessOpportunitiesScreenV2 extends React.Component {
  constructor(props) {
    super(props);
  }

  stateMPartFromDashboard() {
    return this.state.part;
  }

  componentDidMount() {}

  render() {
    return (
      <Listing_screen
        listId={"df-business-oppo-paidup-list"} //To define which list this is loading for
        countId={"df-business-oppo-count"} //To define which count to retrieve
        module={"businessOpportunity"} //To define which module this list is for
        detailRoute={Config.routes.generic.businessOpportunity} //Route to detail screen
        listingTitle={"Business Opportunities"} //Title of listing
        part={"dashboard"}
        dateRange={"overall"}
      />
    );
  }
}

export default withRouter(BusinessOpportunitiesScreenV2);
